module.exports = {"svg":{"$":{"width":"128","height":"128","xmlns":"http://www.w3.org/2000/svg"},"g":[{"path":[{"$":{"d":"M115.625 127.937H.063V12.375h57.781v12.374H12.438v90.813h90.813V70.156h12.374z"}},{"$":{"d":"M116.426 2.821l8.753 8.753-56.734 56.734-8.753-8.745z"}},{"$":{"d":"M127.893 37.982h-12.375V12.375H88.706V0h39.187z"}}]}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/link.svg
// module id = 388
// module chunks = 0